// extracted by mini-css-extract-plugin
module.exports = {"grid":"SlotButtons-module__grid___DVNEj","button":"SlotButtons-module__button___vjuq4"};